import { Pipe, PipeTransform } from '@angular/core';

export enum CutOffTime { TWO_PM = 'TwoPM', THREE_PM = 'ThreePM', FOUR_PM = 'FourPM', FIVE_PM = 'FivePM' }
@Pipe({
  name: 'cutOffTime',
})
export class CutOffTimePipe implements PipeTransform {
  transform(cutOffTimeValue: CutOffTime = CutOffTime.TWO_PM, arg?: any): boolean {
    const currentTime = new Date();
    const mappedCutOffTime: Array<{ id: number; value: CutOffTime }> = [
      { id: 14, value: CutOffTime.TWO_PM },
      { id: 15, value: CutOffTime.THREE_PM },
      { id: 16, value: CutOffTime.FOUR_PM },
      { id: 17, value: CutOffTime.FIVE_PM },
    ];
    const _ = mappedCutOffTime.find((t) => t.value === cutOffTimeValue);
    if (!!!_) return false;
    return currentTime.getHours() >= _.id;
  }
}
